module.exports = __webpack_public_path__ + "img/Villa_Borna_25.d953a804.jpg";